
















import {
  defineComponent,
  ref,
  watch,
} from '@vue/composition-api';
import type { PropType } from '@vue/composition-api';
import { Tabs, TabItem as Tab } from '@hb/coffee';

export default defineComponent({
  name: 'TabBar',
  components: {
    Tab,
    Tabs,
  },
  props: {
    listDatas: {
      type: Array as PropType<{ label: string }[]>,
      required: true,
    },
    activeIndex: {
      type: Number,
      required: true,
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['selectedChange'],
  setup(props, context) {
    const selected = ref(0);

    watch(() => props.activeIndex, (newVal) => {
      selected.value = newVal;
    }, {
      immediate: true,
    });

    const onSelect = (index: number) => {
      selected.value = index;
      context.emit('selectedChange', selected.value);
    };

    return {
      selected,
      onSelect,
    };
  },
});
